// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { PrimaryClientDropdown_HouseholdWithPrimaryClientsFragment } from '../../../entities/inputs/PrimaryClientDropdown/graphql/PrimaryClientDropdown.generated';
import { BeneficiaryDropdown_HouseholdFragment } from '../../../entities/inputs/BeneficiaryDropdown/graphql/BeneficiaryDropdown.generated';
import { gql } from '@apollo/client';
import { PrimaryClientDropdown_HouseholdWithPrimaryClientsFragmentDoc } from '../../../entities/inputs/PrimaryClientDropdown/graphql/PrimaryClientDropdown.generated';
import { BeneficiaryDropdown_HouseholdFragmentDoc } from '../../../entities/inputs/BeneficiaryDropdown/graphql/BeneficiaryDropdown.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LogNewGiftModalFormOptionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
}>;


export type LogNewGiftModalFormOptionsQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & PrimaryClientDropdown_HouseholdWithPrimaryClientsFragment
        & BeneficiaryDropdown_HouseholdFragment
      ) | null } | null> | null } };

export type DeleteTransferAndExclusionEventMutationVariables = Types.Exact<{
  deleteLifetimeExclusionEventId: Types.Scalars['ID']['input'];
  deleteLoggedTransferId: Types.Scalars['ID']['input'];
}>;


export type DeleteTransferAndExclusionEventMutation = { __typename?: 'Mutation', deleteLifetimeExclusionEvent: string, deleteLoggedTransfer: string };

export const Operations = {
  Query: {
    LogNewGiftModalFormOptions: 'LogNewGiftModalFormOptions' as const
  },
  Mutation: {
    DeleteTransferAndExclusionEvent: 'DeleteTransferAndExclusionEvent' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const LogNewGiftModalFormOptionsDocument = gql`
    query LogNewGiftModalFormOptions($where: HouseholdWhereInput) {
  households(where: $where) {
    edges {
      node {
        ...PrimaryClientDropdown_HouseholdWithPrimaryClients
        ...BeneficiaryDropdown_Household
      }
    }
  }
}
    ${PrimaryClientDropdown_HouseholdWithPrimaryClientsFragmentDoc}
${BeneficiaryDropdown_HouseholdFragmentDoc}`;

/**
 * __useLogNewGiftModalFormOptionsQuery__
 *
 * To run a query within a React component, call `useLogNewGiftModalFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogNewGiftModalFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogNewGiftModalFormOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLogNewGiftModalFormOptionsQuery(baseOptions?: Apollo.QueryHookOptions<LogNewGiftModalFormOptionsQuery, LogNewGiftModalFormOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogNewGiftModalFormOptionsQuery, LogNewGiftModalFormOptionsQueryVariables>(LogNewGiftModalFormOptionsDocument, withFetchPolicyContext(options));
      }
export function useLogNewGiftModalFormOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogNewGiftModalFormOptionsQuery, LogNewGiftModalFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogNewGiftModalFormOptionsQuery, LogNewGiftModalFormOptionsQueryVariables>(LogNewGiftModalFormOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useLogNewGiftModalFormOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LogNewGiftModalFormOptionsQuery, LogNewGiftModalFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogNewGiftModalFormOptionsQuery, LogNewGiftModalFormOptionsQueryVariables>(LogNewGiftModalFormOptionsDocument, withFetchPolicyContext(options));
        }
export type LogNewGiftModalFormOptionsQueryHookResult = ReturnType<typeof useLogNewGiftModalFormOptionsQuery>;
export type LogNewGiftModalFormOptionsLazyQueryHookResult = ReturnType<typeof useLogNewGiftModalFormOptionsLazyQuery>;
export type LogNewGiftModalFormOptionsSuspenseQueryHookResult = ReturnType<typeof useLogNewGiftModalFormOptionsSuspenseQuery>;
export type LogNewGiftModalFormOptionsQueryResult = Apollo.QueryResult<LogNewGiftModalFormOptionsQuery, LogNewGiftModalFormOptionsQueryVariables>;
export const DeleteTransferAndExclusionEventDocument = gql`
    mutation DeleteTransferAndExclusionEvent($deleteLifetimeExclusionEventId: ID!, $deleteLoggedTransferId: ID!) {
  deleteLifetimeExclusionEvent(id: $deleteLifetimeExclusionEventId)
  deleteLoggedTransfer(id: $deleteLoggedTransferId)
}
    `;
export type DeleteTransferAndExclusionEventMutationFn = Apollo.MutationFunction<DeleteTransferAndExclusionEventMutation, DeleteTransferAndExclusionEventMutationVariables>;

/**
 * __useDeleteTransferAndExclusionEventMutation__
 *
 * To run a mutation, you first call `useDeleteTransferAndExclusionEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransferAndExclusionEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransferAndExclusionEventMutation, { data, loading, error }] = useDeleteTransferAndExclusionEventMutation({
 *   variables: {
 *      deleteLifetimeExclusionEventId: // value for 'deleteLifetimeExclusionEventId'
 *      deleteLoggedTransferId: // value for 'deleteLoggedTransferId'
 *   },
 * });
 */
export function useDeleteTransferAndExclusionEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransferAndExclusionEventMutation, DeleteTransferAndExclusionEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransferAndExclusionEventMutation, DeleteTransferAndExclusionEventMutationVariables>(DeleteTransferAndExclusionEventDocument, options);
      }
export type DeleteTransferAndExclusionEventMutationHookResult = ReturnType<typeof useDeleteTransferAndExclusionEventMutation>;
export type DeleteTransferAndExclusionEventMutationResult = Apollo.MutationResult<DeleteTransferAndExclusionEventMutation>;
export type DeleteTransferAndExclusionEventMutationOptions = Apollo.BaseMutationOptions<DeleteTransferAndExclusionEventMutation, DeleteTransferAndExclusionEventMutationVariables>;